module.exports = "<router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/app-layouts/empty-layout.component.html
// module id = ./src/app/shared/layout/app-layouts/empty-layout.component.html
// module chunks = main